var map = {
	"./article@2x.png": 664,
	"./brandasset@2x.png": 5497,
	"./campaign@2x.png": 6635,
	"./industryevent@2x.png": 2977,
	"./product@2x.png": 4494,
	"./science@2x.png": 2168,
	"./searchIcon@2x.png": 284
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5931;